<lib-site-setup-navbar class="w-full" [loggedInUser]="vm().currentUser" [useLocationNavigation]="true"></lib-site-setup-navbar>

<div class="mb-10 mt-10 flex flex-col gap-4 xs:mt-16 xs:flex-row xs:justify-between xs:gap-0">
  <h1 class="typo-h1 font-semibold">{{ 'site_setup_help_title' | translate }}</h1>
  <a class="btn btn-secondary justify-center" href="mailto:customersuccess@ffd.ai">{{ 'site_setup_help_button' | translate }}</a>
</div>

<section class="mb-10 grid grid-cols-1 gap-4 xs:grid-cols-4">
  @for (video of videos; track video) {
    <div class="flex flex-col gap-2">
      <lib-onboarding-video
        libPreviewVideo
        class="!h-auto"
        [videoTitle]="'site_setup_help_video1_title' | translate"
        [thumbnailUrl]="video.thumbnailUrl || ''"
        [videoUrl]="video.videoUrl || ''"
        [fileType]="video.fileType || ''"
        [previewOnly]="true"
        [installationContractId]="vm().contract?.data?.id"
        tutorialModule="site_installation"
      ></lib-onboarding-video>
      <p class="typo-h5-semibold text-text-primary">{{ video.title | translate }}</p>
      <h6 class="typo-h7-extralight text-text-primary">{{ video.description || '' | translate }}</h6>
    </div>
  }
</section>

<section>
  <h4 class="typo-h4-semibold mb-4">{{ 'site_setup_help_faq_title' | translate }}</h4>

  <div class="rounded-[24px] bg-background-light-blue">
    <cdk-accordion [multi]="true">
      @for (faq of faqs; track faq) {
        <lib-faq-card [question]="faq.question" [answer]="faq.answer"></lib-faq-card>
      }
    </cdk-accordion>
  </div>
</section>
